// extracted by mini-css-extract-plugin
export default {"audience":"Audience_audience__omn0-","audienceLeft":"Audience_audienceLeft__Q+qsd","audienceRight":"Audience_audienceRight__ELYah"};